import ObjectHelper from 'approot/common/lib/ObjectHelper';
import dateTimeFormat from 'config/dateTimeFormat';
import FormatHelper from 'approot/common/lib/FormatHelper';
import store from '../app/store';
import esgConfig from 'approot/api/esg/esgConfig';


const esgConverter = {
	convertResponse: (wResponse) => {
		let questionnaire = { acknowQuestionnaireList: [], acknowAnswerList: [] };
		if (!ObjectHelper.isNullOrEmpty(wResponse)) {
			const textList = wResponse.response.data.questionnaireTexts.filter((el) => el.questionnaireTextName.startsWith('QT_'));
			for (let i = 0; i < textList.length; i++) {
				let questionnaireTextArray = [];
				const keyIndex = i + 1;
				questionnaireTextArray = textList.filter((el) => el.questionnaireTextName.startsWith('QT_' + keyIndex) && el.questionnaireTextName !== 'QT_3-1_001');
				if (questionnaireTextArray.length > 0) {
					questionnaire.acknowQuestionnaireList.push(questionnaireTextArray);
				}
			}
			questionnaire.acknowAnswerList = wResponse.response.data.questionnaireTexts.filter((el) => el.questionnaireTextName.substring(0, 4) === 'AT_1' || el.questionnaireTextName.substring(0, 4) === 'AT_2' || el.questionnaireTextName.substring(0, 4) === 'AT_3' || el.questionnaireTextName.substring(0, 4) === 'AT_3-1');

		}
		return questionnaire;
	},
	//submit request data
	buildSubmitRequest: (data) => {
		let request = {
			action: 'A',
			response: {
				questionnaireId: 70,
				externalId: null,
				captureDateTime: '',
				expiryDateTime: '',
				employeeNumber: '29000101',
				channelCode: 'OHB',
				questionResponse: [],
				totalScore: 0,
				result: null,
				additionalItem: null,
				document: null
			}
		};
		request.response.questionResponse = data;
		return request;
	},
	buildSubmitRequest_wealth: (data) => {
		const { session } = store.getState();
		let request = {
			data: {
				actionCode: 'A',
				questionnaireResponse: {
					questionnaireIdentifier: process.env.REACT_APP_QUES_ID,
					externalId: null,
					captureDateTime: '',
					expiryDateTime: '',
					employeeNumber: session.staffID,
					channelCode: session.chnlID,
					questionResponses: [],
					totalScore: 0,
					result: null,
					additionalItem: null,
					document: null
				}
			}
		};
		let dataused = [...data];
		dataused = dataused.map((item)=>item.questionResponseInputText === null?{...item, questionResponseInputText: ''}:item);
		request.data.questionnaireResponse.questionResponses = dataused;
		return request;
	},
	//retrieve questionnaire responses
	buildRetrieveResponsesRequest: (data) => {
		let request = {
			search: [{
				questionnaireType: 'ESG',
				count: data.count
			}]
		};
		return request;
	},
	//retrieve questionnaire responses
	buildRetrieveResponsesRequest_wealth: (data) => {
		console.log(data);
		const request = 'limit='+data.count+'&page=1&questionnaireType=ESG';
		return request;
	},

	//convert retrieve responses
	convertQuestionnaireResults: (response) => {
		let result = { customerId: '', resultType: '', finalCode: '', captureDateTime: '', expiryDate: '', staffId: '', historyList: []};
		const { session } = store.getState();
		if (!ObjectHelper.isNullOrEmpty(response)) {
			const results = response.data.questionnaireResponseResults;
			if (!ObjectHelper.isNullOrlengthZore(results)) {
				let res = results[0];
				if (!ObjectHelper.isNullOrlengthZore(res.customer)) {
					result.customerId = res.customer[0].customerId;
				}
				const resultRes = res.questionnaireResponses;
				if (!ObjectHelper.isNullOrlengthZore(resultRes)) {
					if (session.locale === 'en_US') {
						result.captureDateTime = FormatHelper.dateFormatPattern(resultRes[0].questionnaireCaptureDateTime, dateTimeFormat.DATE_TIME_FORMAT_English) + ' at ' +
						FormatHelper.dateFormatPattern(resultRes[0].questionnaireCaptureDateTime, dateTimeFormat.DATE_TIME_FORMAT_English_Time);
					}else {
						result.captureDateTime = FormatHelper.dateFormatPattern(resultRes[0].questionnaireCaptureDateTime, dateTimeFormat.DATE_TIME_FORMAT);
					}
					resultRes.forEach(item => {
						const obj = { captureDateTime: FormatHelper.dateFormatPattern(item.questionnaireCaptureDateTime, dateTimeFormat.DATE_TIME_FORMAT) }; //, expiryDate: FormatHelper.dateFormatPattern(item.expiryDateTime, dateTimeFormat.DATE_TIME_FORMAT), resultType: tt[0].resultType, finalCode: tt[0].finalCode };

						if (!ObjectHelper.isNullOrlengthZore(item.questionResponses)) {
							obj.questionResponse = item.questionResponses;

						}
						result.historyList.push(obj);
					});
				}
			}
		}
		return result;
	},
	validateInput: (questionAnswers, questionnaire) => {
		if (questionnaire) {
			let length = questionnaire.acknowQuestionnaireList.length;
			let emptyAns = [];
			let allAnswers = true;
			for (let i = 0; i < length; i++) {
				let tempAnswer = questionAnswers.filter(item => (item.questionNumber === String(i + 1)));
				if (tempAnswer.length < 1) {
					allAnswers = false;
					emptyAns.push(String(i + 1));
				}
				else if (tempAnswer[0].questionNumber === '1' && tempAnswer[0].questionResponseCode === '2') {
					//I do not wish to consider sustainable investing, only one answer save to db
					allAnswers = true;
					questionAnswers = tempAnswer;
					break;
				}
				else if (tempAnswer[0].questionNumber === '3' && tempAnswer[0].questionResponseCode === '2') {
					//I have particular interest in UN SDG, no options selected then false
					let tempAnswer1 = questionAnswers.filter(item => (item.questionNumber === '3-1'));
					if (tempAnswer1.length < 1) {
						allAnswers = false;
						emptyAns.push('3');
					}
				}
			}

			if (!allAnswers) {
				const acknowQuestionnaireList = questionnaire.acknowQuestionnaireList;
				for (let item of acknowQuestionnaireList) {
					const list = emptyAns.filter((e) => item[0].questionnaireTextName.substring(3, 4) === e);
					if (ObjectHelper.isNullOrlengthZore(list)) {
						item.isValiInput = false;
					} else {
						item.isValiInput = true;
					}
				}
			}
		}
	},
	updateValidateInput: (questionAnswers, questionNumber, questionnaire) => {
		if (questionnaire) {
			const acknowQuestionnaireList = questionnaire.acknowQuestionnaireList;
			if (questionNumber === '3' || questionNumber === '3-1') {
				const tempAnswer1 = questionAnswers.filter(item => (item.questionNumber === '3' && item.questionResponseCode === '1'));
				if (tempAnswer1.length > 0) {

					for (let item of acknowQuestionnaireList) {
						if (item[0].questionnaireTextName.substring(3, 4) === '3') {
							item.isValiInput = false;
						}
					}
				}
				const tempAnswer2 = questionAnswers.filter(item => (item.questionNumber === '3' && item.questionResponseCode === '2'));
				let tempAnswer3 = questionAnswers.filter(item => (item.questionNumber === '3-1'));
				if (tempAnswer2.length > 0 && tempAnswer3.length > 0) {

					for (let item of acknowQuestionnaireList) {
						if (item[0].questionnaireTextName.substring(3, 4) === '3') {
							item.isValiInput = false;
						}
					}
				}
			}
			else {

				for (let item of acknowQuestionnaireList) {
					if (item[0].questionnaireTextName.substring(3, 4) === questionNumber) {
						item.isValiInput = false;
					}
				}
			}
		}
	},

	buildReportGenerateRequest: (responseId) => {
		const { session } = store.getState();
		// {
		// 	'locale': {
		// 		'locale': 'en-US',
		// 		'title': 'English'
		// 	},
		// 	'localeIntl': 'en-US',
		// 	'sessionId': 'NA',
		// 	'staffID': '43457392',
		// 	'customerName': 'Allen',
		// 	'lob': 'ESG',
		// 	'chnlCC': 'SG',
		// 	'chnlGMC': 'HBSP',
		// 	'custCC': 'SG',
		// 	'custGMC': 'HBSP',
		// 	'custID': 'SGHBSP142025659',
		// 	'bizLine': 'PFS',
		// 	'targetFunc': 'esgHome',
		// 	'chnlID': 'OHB',
		// 	'isDualRecordOn': false,
		// 	'isSuperVisorMode': false,
		// 	'calculateResult': '',
		// 	'currentAnswers': []
		// }
		let dataCollectionSource = {};

		dataCollectionSource.method = 'POST';
		let params = {
			'serviceContext': {
				'countryCode': session.chnlCC,
				'groupMember': session.chnlGMC,
				'channelId': session.chnlID,
				'businessLine': session.bizLine,
				'consumerId': 'SFP',
				'localeCode': session.locale.replace('-', '_'),
				'userId': session.custID,
				'employeeUserId': session.staffID
			},
			'customer': [{
				'countryCode': session.custCC,
				'groupMemberCode': (!ObjectHelper.isNullOrEmpty(session.jointCustID) ? session.custID.substring(2, 6) : session.custGMC),
				'sourceSystemCode': 'CDM',
				'customerId': session.custID
			}],
			'search': [{
				'questionnaireType': 'ESG',
				'count': 1
			}],
			'questionnairesId': responseId,
			'accountNumber': session.custID,
			'staffName': session.staffFullName,
			'customerName': ''
		};
		if (session.customerName !== undefined && session.customerName !== null) {
			params.customerName = session.customerName;
		}
		dataCollectionSource.params = JSON.stringify(params);
		dataCollectionSource.path = esgConfig.reportGeneratePath;
		let request =

		{
			'customerId': 'dummyCustomerID',
			'dataCollectionSource': dataCollectionSource,
			'reportType': esgConfig.reportType,
			'sourceChannel': session.chnlID,
			'title': esgConfig.reportTitle,
			'userId': session.staffID,
			'docId': ''
		};

		return request;
	},

	buildAndSubmitAppForm: (paramObject, actionUrl, isPopup, windowName) => {
		let formObj = document.createElement('form');
		formObj.id = 'intgTempForm';
		formObj.name = 'intgTempForm';
		formObj.method = 'post';
		formObj.action = actionUrl;
		document.body.appendChild(formObj);

		for (let fieldKey in paramObject) {
			if (paramObject[fieldKey]) {
				let paramInput = document.createElement('input');
				paramInput.type = 'hidden';
				paramInput.name = fieldKey;
				paramInput.value = paramObject[fieldKey];
				formObj.appendChild(paramInput);
			}
		}

		console.log('esg buildAndSubmitAppForm paramObject', paramObject);
		console.log('esg buildAndSubmitAppForm actionUrl', actionUrl);
		console.log('esg buildAndSubmitAppForm isPopup', isPopup);

		if (isPopup) {
			formObj.target = windowName;
			let newWin = window.open('', windowName);

			if (newWin) {
				newWin.focus();
				formObj.submit();
				document.body.removeChild(formObj);
			}
		} else {
			formObj.target = '_self';
			formObj.submit();
		}
	}
};

export default esgConverter;
